import { BookmakerBlacklistIcon } from "../icons";
import Create from "./Create";
import List from "./List";

export default {
	options: {
		group: "bookmakers",
		roles: ["admin"],
	},
	icon: BookmakerBlacklistIcon,
	list: List,
	create: Create,
};
